import axios, { AxiosRequestConfig } from "axios";
// import { api } from "../config";

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// This is the axios instance configuration for making API requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authUser');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// intercepting to capture errors
axiosInstance.interceptors.response.use(
  function (response) {
    return response?.data ? response?.data : response;
  },
  async function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;

    if (!error.response) {
      message = "Network Error";
      return {
        success: false,
        message: "Network Error",
        data: null,
      };
    }
    switch (error?.response?.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        // Clear stored tokens and redirect to login
        localStorage.removeItem('authUser');
        localStorage.removeItem('refreshToken');

        // Redirect to login page
        window.location.href = '/login';

        message = "Session expired. Please login again.";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = error?.response?.data?.error?.message || error?.message || error;
    }
    return Promise.reject(message);
  }
);

function getCookie(name: string) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
  return null;
}

// intercepting to set request verification token
axiosInstance.interceptors.request.use(
  function (request) {
    const token = getCookie('XSRF-TOKEN');
    if (token) {
      request.headers["requestverificationtoken"] = token;
    }
    return request;
  },
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: any) => {
  axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url: any, params: any) => {
    let response;

    let paramKeys: any = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axiosInstance.get(`${url}?${queryString}`, {
        withCredentials: true
      });
    } else {
      response = axiosInstance.get(`${url}`, {
        withCredentials: true
      } as AxiosRequestConfig);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url: any, data: any, validateStatus?: (statusNumber: number) => boolean) => {
    const isFormData = data instanceof FormData;
    const config: any = {};

    if (isFormData) {
      // For FormData, remove Content-Type header to let browser set it with boundary
      config.headers = {
        'Content-Type': undefined,
      };
    }

    if (validateStatus) {
      config.validateStatus = validateStatus;
    }

    return axiosInstance.post(url, data, config);
  };
  /**
   * Updates data
   */
  update = (url: any, data: any) => {
    return axiosInstance.patch(url, data);
  };

  put = (url: any, data: any, validateStatus?: (statusNumber: number) => boolean) => {
    return validateStatus
      ?
      axiosInstance.put(url, data, {
        headers: {
          'Content-Type': 'application/json',
        }, validateStatus
      })
      : axiosInstance.put(url, data, {
        headers: {
          'Content-Type': 'application/json',
        }
      })
  };

  /**
   * Delete
   */
  delete = (url: any, config: any) => {
    return axiosInstance.delete(url, { ...config });
  };
}
const getLoggedUser = () => {

  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedUser };